import * as React from 'react';

export default class SearchForm extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        return (
            <form>
                <input
                    type="text"
                    className="input"
                    placeholder={`Buscar ${this.props.itemName}`}
                    value={this.props.filterText}
                    ref="filterTextInput"
                    onChange={(e) => this.props.onInput(e.currentTarget.value)}
                />
            </form>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/searchForm/SearchForm.js